import React from 'react';
import { 
  ClockIcon, 
  CogIcon,
  DocumentMagnifyingGlassIcon,
  ArrowPathIcon
} from '@heroicons/react/24/outline';

interface ApplicationStatusBadgeProps {
  status: string | null;
}

const STATUS_CONFIG: Record<string, { label: string; color: string; icon: React.ComponentType<any> }> = {
  'processing_pd_pipeline': {
    label: 'Обработка документации',
    color: 'bg-blue-100 text-blue-800 border-blue-300',
    icon: DocumentMagnifyingGlassIcon
  },
  'selecting_products': {
    label: 'Подбор оборудования',
    color: 'bg-purple-100 text-purple-800 border-purple-300',
    icon: CogIcon
  },
  'reselecting_brands': {
    label: 'Переподбор брендов',
    color: 'bg-amber-100 text-amber-800 border-amber-300',
    icon: ArrowPathIcon
  },
  'processing_schemes': {
    label: 'Обработка схем',
    color: 'bg-cyan-100 text-cyan-800 border-cyan-300',
    icon: ClockIcon
  }
};

const ApplicationStatusBadge: React.FC<ApplicationStatusBadgeProps> = ({ status }) => {
  if (!status) {
    return null;
  }

  const config = STATUS_CONFIG[status];
  
  if (!config) {
    // Fallback для неизвестных статусов
    return (
      <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-800 border border-gray-300">
        <ClockIcon className="h-3.5 w-3.5" />
        <span>Обработка...</span>
      </span>
    );
  }

  const Icon = config.icon;

  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium border ${config.color}`}>
      <Icon className="h-3.5 w-3.5 animate-pulse" />
      <span>{config.label}</span>
    </span>
  );
};

export default ApplicationStatusBadge;
